import { useFormikContext } from "formik";
import React, { useEffect } from "react";
import { getName, labelName } from "../../../utils/functions";
import ErrorMessage from "../ErrorrMessage";
import textFieldStyles from "../TextField/TextField.module.css";
import styles from "./Checkbox.module.css";

export default function CheckBox({ field_label, field_items, parent, isRequired }) {
  const name = getName(parent, field_label);

  return (
    <div className={textFieldStyles.inputContainer}>
      <label className={textFieldStyles.label}>{field_label}{isRequired==="true" && <span style={{ color: '#d32f2f', padding: 0 }}>*</span>}</label>
      <div className={styles.checkContainer}>
        {field_items &&
          field_items.length > 0 &&
          field_items.map((item, index) => (
            <CheckBoxInput
              key={`${item}-${index}`}
              title={item}
              name={name}
              parent={parent}
            />
          ))}
      </div>
      <ErrorMessage name={field_label} />
    </div>
  );
}

const CheckBoxInput = ({ title, name }) => {
  const { setFieldValue, values } = useFormikContext();

  const handleChange = (value) => {
    let $values = values[name];
    if ($values?.includes(value)) {
      $values = $values.filter((item) => item !== value);
    } else {
      $values?.push(value);
    }
    setFieldValue(name, $values);
  };

  return (
    // <label className={styles.checkLabel}>
    //   <input
    //     type="checkbox"
    //     value={title}
    //     onChange={(e) => handleChange(e.target.value)}
    //   />
    //   <span className={styles.checkmark}>{title}</span>
    // </label>
    <label className={styles.container}>
      {labelName(title)}
      <input
        type="checkbox"
        value={title}
        onChange={(e) => handleChange(e.target.value)}
      />
      <span className={styles.checkmark}></span>
    </label>
  );
};
